import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import AddNamaaz from './pages/AddNamaaz';
import NamaazCalculator from './pages/NamaazCalculator';
import Login from './pages/Login';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/add" element={<AddNamaaz />} />
        <Route path="/init" element={<NamaazCalculator />} />
        <Route path="/login" element={<Login />} />
        
      </Routes>
    </Router>
  );
}

export default App;
